import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { usePrevious } from '../usePrevious';

// ────────────────────────────────────────────────────────────────────────────────

export const useNewException = (exception?: Exception) => {
  const { formatMessage } = useIntl();
  const prevException = usePrevious(exception);

  const hasNewException = Boolean(!prevException && exception);
  const exceptionMessage =
    exception?.message ?? formatMessage(messages.exceptionError);

  return useMemo(
    () => ({ hasNewException, exceptionMessage }),
    [exceptionMessage, hasNewException],
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type Exception = Readonly<{
  message?: string;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  exceptionError: {
    defaultMessage: 'Something went wrong, try again in a few moments...',
    description: 'New Exception | Error',
  },
});
